"use client";
import { usePathname } from "next/navigation";
import SearchPill from "@/components/SearchForm/SearchPill";

// Compact header search for partner storefronts — parity with the global
// NavBar, which always shows the header pill on /search. Only the scoped
// search results page needs it; the landing page has the full hero pill.
// Desktop-only: mobile search results carry their own sticky bar.
const PartnerHeaderSearch = () => {
  const pathname = usePathname() || "";
  if (!/^\/partner\/[^/]+\/search\/?$/.test(pathname)) return null;
  return (
    <div className="flex-1 mx-4 hidden lg:block">
      <SearchPill type="header" />
    </div>
  );
};

export default PartnerHeaderSearch;
